<template>
  <div class="d-flex justify-content-end mc-table-filter_cut-off-automation">
    <div>
      <McTableFilter
        ref="engineOffAutomationFilter"
        :activeFilters="activeFilters"
        :parseFilterDataMappings="parseFilterDataMappings"
        :hasCustomEvent="hasCustomEvent"
        :hasChangeData="hasChangeData"
        @submit="handleInput"
        @reset="handleReset"
      >
        <template #content="{ formValues, updateFormValues, fullObjects, updateFullObjects }">
          <div class="mc-modal__filter-item">
            <FormulateInput
              v-bind="vGroupFields"
              :fullObject="fullObjects['fleetGroup']"
              :value="formValues.fleetGroup"
              @update:formValues="updateFormValues({ key: 'fleetGroup', value: $event })"
              @update:fullObject="updateFullObjects({ key: 'fleetGroup', value: $event })"
            />
          </div>
          <div class="mc-modal__filter-item ms-1">
            <p class="teal-300">
              {{ $t('global.object.status') }}
            </p>
            <b-row>
              <McRadioButton
                id="statusAll"
                v-model="formValues.status"
                name="status"
                :initialValue="'all'"
                :label="$t('global.filter.all')"
                :disabled="isNotScheduled"
              />
            </b-row>
            <b-row>
              <McRadioButton
                id="statusActive"
                v-model="formValues.status"
                name="status"
                :initialValue="'Active'"
                :label="$t('global.active')"
                :disabled="isNotScheduled"
              />
            </b-row>
            <b-row>
              <McRadioButton
                id="statusNotActive"
                v-model="formValues.status"
                name="status"
                :initialValue="'NonActive'"
                :label="$t('global.nonActive3')"
                :disabled="isNotScheduled"
              />
            </b-row>
          </div>
          <div class="mc-modal__filter-item">
            <FormulateInput
              type="group"
              name="days"
              :label="$t('global.time.days')"
              :value="(formValues.days = selectedDays[0])"
              :disabled="isNotScheduled"
            >
              <div class="mc-modal__filter-button-group">
                <button
                  v-for="day in daysList"
                  :key="day.key"
                  type="button"
                  :class="[
                    'mc-modal__filter-button',
                    { 'mc-modal__filter-button--active': listDays[day.key] },
                    { 'mc-modal__filter-button--disabled': isNotScheduled },
                  ]"
                  :disabled="isNotScheduled && day.key !== 'all'"
                  @click="filterDaySelection(day.key)"
                >
                  {{ day.label }}
                </button>
              </div>
            </FormulateInput>
          </div>
          <div class="mc-modal__filter-item">
            <p class="m-1">
              {{ $t('global.object.timeRange') }}
            </p>
            <b-row>
              <b-col md="6">
                <FormulateInput
                  name="startTime"
                  :label="$t('global.object.startTime')"
                  type="time"
                  :value="formValues.startTime"
                  :disabled="isNotScheduled"
                  :placeholder="`${$t('global.form.select')} ${$t('global.field.date')}`"
                />
              </b-col>
              <b-col md="6">
                <FormulateInput
                  name="endTime"
                  :label="$t('global.object.endTime')"
                  type="time"
                  :value="formValues.endTime"
                  :disabled="isNotScheduled"
                  :placeholder="`${$t('global.form.select')} ${$t('global.field.date')}`"
                />
              </b-col>
            </b-row>
          </div>
        </template>
      </McTableFilter>
    </div>

    <div class="ms-2">
      <McButton
        v-if="isSelected"
        :variant="'secondary-red'"
        :text="$t('global.action.clearSchedule')"
        icon="icon-outline_trash"
        @click="onClearSchedule()"
      />
    </div>

    <div :class="isSelected ? 'ms-2' : ''">
      <b-dropdown variant="outline-primary" class="mb-2" :disabled="!isSelected">
        <template #button-content>
          {{ `${$t('global.update')} Status` }}
          <i class="mdi mdi-chevron-down" />
        </template>
        <b-dropdown-item @click="showUpdateStatus('Active')">
          {{ $t('global.active') }}
        </b-dropdown-item>
        <b-dropdown-item @click="showUpdateStatus('NonActive')">
          {{ $t('global.nonActive3') }}
        </b-dropdown-item>
      </b-dropdown>
    </div>

    <b-modal
      id="mc-modal-clear_scheduled"
      ref="mc-modal-clear_scheduled"
      class="mc-modal"
      :title="$t('global.action.clearSchedule')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <McAlert
          v-if="hasStatusActive"
          class="mb-3"
          variant="warning"
          :html="$t('setting.cutOffAutomation.message.confirmClearScheduleWarning')"
          withIcon
          :withGap="false"
        />
        <p
          v-html="
            sanitizeHTML(
              $t('setting.cutOffAutomation.message.confirmClearSchedule', {
                selected: `<strong>${isSelected}</strong>`,
              })
            )
          "
        ></p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            :text="$t('global.action.cancel')"
            class="me-2"
            @click="cancel()"
          />
          <McButton
            variant="primary"
            :text="$t('global.action.clearSchedule')"
            @click="handleClearSchedule()"
          />
        </div>
      </template>
    </b-modal>

    <b-modal
      id="mc-modal-update_status"
      ref="mc-modal-update_status"
      class="mc-modal"
      :title="$t('global.action.clearSchedule')"
      size="md"
      centered
      scrollable
    >
      <div class="card-body p-2">
        <p>
          <span
            v-html="
              sanitizeHTML(
                $t('setting.cutOffAutomation.message.confirmUpdateSchedule', {
                  selected: `<strong>${isSelected}</strong>`,
                })
              )
            "
          ></span>
          <strong class="ms-1">{{
            status === 'Active' ? $t('global.active') : $t('global.nonActive3')
          }}</strong>
        </p>
      </div>
      <template #modal-footer="{ cancel }">
        <div class="d-flex">
          <McButton
            variant="secondary"
            :text="$t('global.action.cancel')"
            class="me-2"
            @click="cancel()"
          />
          <McButton variant="primary" :text="$t('global.update')" @click="handleUpdateStatus()" />
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import McTableFilter from '@/components/McTableFilter'
import McButton from '@/components/McButton'
import McRadioButton from '@/components/McRadioButton'
import McAlert from '@/components/McAlert'
import { Helper } from '@/mixin/helper'
import { GET_VGROUPS_PAGINATED } from '@/services/api/vehicle/vgroup'
export default {
  components: {
    McTableFilter,
    McButton,
    McRadioButton,
    McAlert,
  },
  mixins: [Helper],
  props: {
    activeFilters: {
      required: true,
    },
    handleChangeActiveFilters: {
      type: Function,
    },
    isSelected: {},
    selectedItems: {
      type: Array,
      default: () => [],
    },
    selectedIds: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      listDays: {
        all: true,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      },
      selectedDays: [],
      status: 'Active',
      hasStatusActive: false,
      hasCustomEvent: true,
      hasChangeData: false,
    }
  },

  computed: {
    vGroupFields() {
      const tableFields = [
        {
          key: 'name',
          label: this.$t('global.object.fleetGroup'),
          isSortable: false,
        },
        {
          key: 'totalVehicle',
          label: this.$t('global.object.totalFleet'),
          isSortable: false,
        },
      ]
      return {
        name: 'fleetGroup',
        isShow: true,
        label: this.$t('global.object.fleetGroup'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.form.select')} ${this.$t('global.object.fleetGroup')}`,
        trackBy: 'id',
        displayedBy: 'name',
        listGetter: (filter) => this.getFleetGroupList(filter),
        multiple: true,
        tableFields: tableFields,
      }
    },
    daysList() {
      return [
        { key: 'all', label: this.$t('global.filter.all') },
        { key: 'Mon', label: this.$t('global.days.monday') },
        { key: 'Tue', label: this.$t('global.days.tuesday') },
        { key: 'Wed', label: this.$t('global.days.wednesday') },
        { key: 'Thu', label: this.$t('global.days.thursday') },
        { key: 'Fri', label: this.$t('global.days.friday') },
        { key: 'Sat', label: this.$t('global.days.saturday') },
        { key: 'Sun', label: this.$t('global.days.sunday') },
      ]
    },

    isNotScheduled() {
      return this.activeFilters.scheduleType?.includes('NotScheduled')
    },

    parseFilterDataMappings() {
      return {
        fleetGroup: 'vGroupIds',
        status: 'status',
        days: 'days',
        startTime: 'startTime',
        endTime: 'endTime',
      }
    },
  },

  methods: {
    handleInput(value) {
      const mcTableFilter = this.$refs.engineOffAutomationFilter
      const startTime = value.find((item) => item.key === 'startTime')?.values
      const endTime = value.find((item) => item.key === 'endTime')?.values
      if (startTime && !endTime) {
        this.$mcToast.error(
          `${this.$t('global.object.endTime')} ${this.$t('global.validation.required')}`
        )
        mcTableFilter.showModal = true
        return
      }
      if (!startTime && endTime) {
        this.$mcToast.error(
          `${this.$t('global.object.startTime')} ${this.$t('global.validation.required')}`
        )
        mcTableFilter.showModal = true
        return
      }

      if (startTime && endTime) {
        const start = new Date(`2000-01-01T${startTime}`)
        const end = new Date(`2000-01-01T${endTime}`)

        if (start > end) {
          this.$mcToast.error(this.$t('setting.cutOffAutomation.error.startTimeEarlierThanEndTime'))
          mcTableFilter.showModal = true
          return
        }
      }
      const updatedValue = value.map((item) => {
        const { key, values } = item

        return {
          ...item,
          values:
            key === 'vGroupIds' && values
              ? values.map((val) => parseInt(val, 10))
              : key === 'days' && values
              ? this.selectedDays
              : key === 'status' && !values
              ? 'all'
              : values,
        }
      })

      mcTableFilter.showModal = false
      this.$emit('handleChangeActiveFilters', updatedValue)
    },
    handleReset() {
      this.selectedDays = []
      this.listDays = {
        all: true,
        monday: false,
        tuesday: false,
        wednesday: false,
        thursday: false,
        friday: false,
        saturday: false,
        sunday: false,
      }
    },
    filterDaySelection(key) {
      this.hasChangeData = false
      if (key === 'all') {
        Object.keys(this.listDays).forEach((day) => {
          this.listDays[day] = false
        })
        this.listDays.all = true
        this.selectedDays = []
        this.hasCustomEvent = false
      } else {
        this.listDays.all = false
        this.listDays[key] = !this.listDays[key]

        let obj = { ...this.listDays }
        let objArr = []

        if (obj[key] === true) {
          objArr.unshift(key)
        }

        Object.keys(obj).forEach(function (dayKey) {
          if (dayKey !== 'all' && dayKey !== key && obj[dayKey] === true) {
            objArr.push(dayKey)
          }
        })

        this.hasChangeData = true
        this.selectedDays = objArr

        if (this.selectedDays.length === 0) {
          Object.keys(this.listDays).forEach((day) => {
            this.listDays[day] = false
          })
          this.listDays.all = true
          this.hasCustomEvent = false
        }
      }
    },
    async getFleetGroupList(opt) {
      const { ...otherOpt } = opt
      const includedVehicleStatus = ['service', 'repair']
      const response = await this.$apollo.query({
        query: GET_VGROUPS_PAGINATED,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            ...otherOpt,
            includedVehicleStatus
          },
        },
      })
      let res = response.data.vgroupsPaginated.vgroups
      return res
    },
    onClearSchedule() {
      this.hasStatusActive = false

      const selectedVehicleIds = Object.entries(this.selectedIds)
        .filter(([_, isSelected]) => isSelected)
        .map(([vehicleId]) => Number(vehicleId))

      this.hasStatusActive = this.selectedItems.some(
        (item) => selectedVehicleIds.includes(item.vehicleId) && item.isActive
      )

      this.$refs['mc-modal-clear_scheduled'].show()
    },
    handleClearSchedule() {
      this.$refs['mc-modal-clear_scheduled'].hide()
      this.$emit('handleClearSchedule')
    },
    async showUpdateStatus(status) {
      this.status = status
      this.$bvModal.show('mc-modal-update_status')
    },
    handleUpdateStatus() {
      this.$bvModal.hide('mc-modal-update_status')
      this.$emit('handleUpdateStatus', this.status)
    },
  },
}
</script>
